import React, { FC } from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { QuestionType } from './types';
import { FiCheckCircle, FiCheckSquare, FiGitCommit, FiType } from 'react-icons/fi';
import { getQuestionTypeLabel } from '../../util/string';

interface QuestionTypeIconProps {
  questionType: QuestionType;
}

const QuestionTypeIcon: FC<QuestionTypeIconProps> = ({
  questionType
}) => {

  const getIcon = () => {
    switch (questionType) {
      case QuestionType.TEXT:
      return FiType

      case QuestionType.BOOLEAN:
      return FiCheckCircle

      case QuestionType.RANGE_SCALE:
      return FiGitCommit

      case QuestionType.MULTIPLE:
        return FiCheckSquare
    }
  }

  return (
    <HStack justify='end' align='center'>
      <Text color='gray.400' fontWeight='medium' fontSize='sm'>
        {getQuestionTypeLabel(questionType)}
      </Text>
      <Icon color='gray.400' as={getIcon()} />
    </HStack>
  )
};

export default QuestionTypeIcon;
